export default {
      id: "quickbooks-logo-usage",
      viewBox: "0 0 192 37",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#quickbooks-logo",
      toString: function () {
        return this.url;
      }
    }